import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'

// const URL = ({ timeIso }) =>
//
const _URL = () =>
      `http://nrt.cmems-du.eu/thredds/wms/DMI-ARC-SEAICE_TEMP-L4-NRT-OBS?FORMAT=image%2Fpng&TRANSPARENT=TRUE&STYLES=boxfill%2Frainbow&LAYERS=analysed_st&TIME=2018-02-15T12%253A00%253A00.000Z&COLORSCALERANGE=229.78%2C277.57&NUMCOLORBANDS=20&ABOVEMAXCOLOR=0x000000&BELOWMINCOLOR=0x000000&LOGSCALE=false&SERVICE=WMS&VERSION=1.1.1&REQUEST=GetMap&SRS=EPSG%3A4326&BBOX=-64.6875,73.125,-63.28125,74.53125&WIDTH=256&HEIGHT=256`

const URL = ({ timeIso }) =>
      `https://thredds.met.no/thredds/wms/DMI-ARC-SEAICE_TEMP-L4-NRT-OBS/ice_conc_greenland_overview_aggregated?&service=WMS&request=GetMap&layers=ice_concentration&styles=boxfill%2Frainbow&format=image%2Fpng&transparent=true&version=1.1.1&test=0.9384988124610065&COLORSCALERANGE=0%2C100&NUMCOLORBANDS=20&ABOVEMAXCOLOR=0x000000&BELOWMINCOLOR=0x000000&LOGSCALE=false&height=512&width=512&srs=EPSG%3A3857&bbox={bbox-epsg-3857}`

export class CmemsSurfaceTemperature extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const id = 'CmemsSurfaceTemperature'
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { layerRendered, paint, time } = this.props

    const visible = layerRendered
    const before = 'default'
    const timeIso = time ? new Date(time).toISOString() : ''
    const rasterSource = {
      type: 'raster',
      tiles: [URL({ timeIso })],
      tileSize: 256
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id='CmemsSurfaceTemperature' tileJsonSource={rasterSource} />
        <Layer
          type='raster'
          id='CmemsSurfaceTemperature'
          sourceId='CmemsSurfaceTemperature'
          layout={{ visibility: visible ? 'visible' : 'none' }}
          paint={paint}
          before={before}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()

  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, 'CmemsSurfaceTemperature', 'SmartIce'),
      paint: getPaint(state, 'CmemsSurfaceTemperature'),
      time: state.layer.times.CmemsSurfaceTemperature || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(CmemsSurfaceTemperature)



// WEBPACK FOOTER //
// ./src/layers/CmemsSurfaceTemperature.js